class OverviewReport {
    totalInvestedAmount;
    numberOfProperties;
    totalRebatesIncomesAmount;
    totalRentsAmount;
    currentMonthRebatesIncomesAmount;
    currentMonthRentsAmount;
    crowdfunding;
    resale;
    constructor(data) {
        this.totalInvestedAmount = data.totalInvestedAmount;
        this.numberOfProperties = data.numberOfProperties;
        this.totalRebatesIncomesAmount = data.totalRebatesIncomesAmount;
        this.totalRentsAmount = data.totalRentsAmount;
        this.currentMonthRebatesIncomesAmount = data.currentMonthRebatesIncomesAmount;
        this.currentMonthRentsAmount = data.currentMonthRentsAmount;
        this.crowdfunding = data.crowdfunding;
        this.resale = data.resale;
    }
}
export default OverviewReport;
